import React from 'react'

const UnifiedPlatform = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 413.58 413"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#d8f2f1"
                        d="M408.578 26.79V255.37H5V26.79c0-11.867 9.629-21.5 21.5-21.5h360.578c11.871 0 21.5 9.629 21.5 21.5zm0 0"
                        opacity={1}
                        data-original="#d8f2f1"
                    />
                    <path
                        fill="#b9dbd8"
                        d="M14.5 35.621c0-11.867 9.629-21.5 21.5-21.5h360.578c3.3 0 6.414.77 9.207 2.098-3.691-6.52-10.68-10.93-18.707-10.93H26.5C14.629 5.29 5 14.922 5 26.79v228.582h9.5zm0 0"
                        opacity={1}
                        data-original="#b9dbd8"
                    />
                    <path
                        fill="#2f4a5f"
                        d="M408.578 255.371V274c0 11.879-9.629 21.5-21.5 21.5H26.5C14.629 295.5 5 285.879 5 274v-18.629zm0 0"
                        opacity={1}
                        data-original="#2f4a5f"
                    />
                    <path
                        fill="#253c4c"
                        d="M14 284.332v-18.629h394.578v-10.332H5V274c0 7.902 4.277 14.79 10.625 18.523A21.47 21.47 0 0 1 14 284.332zm0 0"
                        opacity={1}
                        data-original="#253c4c"
                    />
                    <path
                        fill="#cc9932"
                        d="M210.79 75.29v90l-80 20v-90zm0 0"
                        opacity={1}
                        data-original="#cc9932"
                        className="hovered-path"
                    />
                    <path
                        fill="#b78429"
                        d="m137.957 101.79 72.832-18.208v-8.293l-80 20v90l7.168-1.793zm0 0"
                        opacity={1}
                        data-original="#b78429"
                        className=""
                    />
                    <path
                        fill="#e2b247"
                        d="M130.79 95.29v90l-80-20v-90zm0 0"
                        opacity={1}
                        data-original="#e2b247"
                    />
                    <path
                        fill="#ce9e3c"
                        d="M57.957 160.29V77.081l-7.168-1.793v90l80 20v-6.793zm0 0"
                        opacity={1}
                        data-original="#ce9e3c"
                    />
                    <path
                        fill="#ffd25d"
                        d="m210.79 75.29-80 20-80-20 80-20zm0 0"
                        opacity={1}
                        data-original="#ffd25d"
                    />
                    <path
                        fill="#e8b94f"
                        d="m132.29 64.29 61.25 15.312 17.25-4.313-80-20-80 20 18.75 4.688zm0 0"
                        opacity={1}
                        data-original="#e8b94f"
                    />
                    <path
                        d="M350.79 324.348h20v20.941h-20zM320.79 324.348h20v20.941h-20zM290.79 324.348h20v20.941h-20zM202.379 331.45c5.18 0 9.383 4.198 9.383 9.39 0 5.18-4.203 9.379-9.383 9.379-5.188 0-9.39-4.2-9.39-9.38a9.387 9.387 0 0 1 9.39-9.39zM110.79 325.29h20v20h-20zM80.79 325.29h20v20h-20zM50.79 325.29h20v20h-20zM267.79 390.29a4.998 4.998 0 0 1-4.77-3.505l-28.153-89.789a5.004 5.004 0 0 1 3.278-6.27 5.006 5.006 0 0 1 6.265 3.278l28.153 89.789a5.004 5.004 0 0 1-3.278 6.27c-.496.152-1 .226-1.496.226zM136.402 390.29c-.496 0-1-.075-1.5-.231a4.996 4.996 0 0 1-3.273-6.266l28.16-89.79a5.001 5.001 0 0 1 6.266-3.273 4.993 4.993 0 0 1 3.273 6.266l-28.156 89.79a5.005 5.005 0 0 1-4.77 3.503zM408.578 260.371H225.121a5 5 0 1 1 0-10h183.457c2.766 0 5 2.238 5 5s-2.234 5-5 5zm0 0"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M225.121 260.371H5a5 5 0 1 1 0-10h220.121a5 5 0 1 1 0 10zM360.79 390.29H55.058c-2.758 0-5-2.24-5-5 0-2.763 2.242-5 5-5h305.73a5 5 0 1 1 0 10zm0 0"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M387.078 300.5H26.5C11.887 300.5 0 288.613 0 274V26.79C0 12.18 11.887.29 26.5.29h360.578c14.613 0 26.5 11.89 26.5 26.5V274c0 14.613-11.887 26.5-26.5 26.5zM26.5 10.29c-9.098 0-16.5 7.401-16.5 16.5V274c0 9.098 7.402 16.5 16.5 16.5h360.578c9.102 0 16.5-7.402 16.5-16.5V26.79c0-9.099-7.398-16.5-16.5-16.5zm0 0"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M130.793 190.29c-.402 0-.809-.048-1.215-.15l-80-20a4.998 4.998 0 0 1-3.789-4.85v-90a5.003 5.003 0 0 1 6.215-4.853l80 20a5 5 0 0 1 3.637 6.067 4.998 4.998 0 0 1-6.063 3.637L55.79 81.69v79.696l76.215 19.05a4.995 4.995 0 0 1 3.637 6.063 4.999 4.999 0 0 1-4.848 3.79zm0 0"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M130.79 190.29a5.003 5.003 0 0 1-5-5v-90a5.005 5.005 0 0 1 3.788-4.853l80-20a5 5 0 0 1 6.21 4.852v90a4.999 4.999 0 0 1-3.784 4.852l-80 20a5.144 5.144 0 0 1-1.215.148zm5-91.099v79.696l70-17.5V81.69zM50.785 80.29a5.006 5.006 0 0 1-4.847-3.786 5.006 5.006 0 0 1 3.64-6.067l80-20c2.676-.671 5.395.961 6.063 3.641a5 5 0 0 1-3.637 6.063l-80 20a5.026 5.026 0 0 1-1.219.148zm0 0"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M210.793 80.29c-.398 0-.809-.048-1.215-.15l-80-20a5 5 0 1 1 2.426-9.703l80 20a5 5 0 0 1-1.21 9.852zM370.79 200.29h-120a5 5 0 1 1 0-10h120a5 5 0 1 1 0 10zM370.79 170.29h-120a5 5 0 1 1 0-10h120a5 5 0 1 1 0 10zM370.79 140.29h-120a5 5 0 1 1 0-10h120a5 5 0 1 1 0 10zM370.79 110.29h-120a5 5 0 1 1 0-10h120a5 5 0 1 1 0 10zM370.79 80.29h-120a5 5 0 1 1 0-10h120a5 5 0 1 1 0 10zm0 0"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default UnifiedPlatform